export const getMemberTierLabel = (badge?: number): string => {
  switch (badge) {
    case 1:
      return 'Free';
    case 2:
      return 'Platinum';
    case 3:
      return 'Silver';
    default:
      return 'No package';
  }
};
